import down from './down'
import Vue from 'vue'
var $downFile
export default {
  install (url, name) {

    if (!$downFile) {
      const downPlugin = Vue.extend(down)
      $downFile = new downPlugin().$mount()
      document.body.appendChild($downFile.$el)
      $downFile.init(url, name)
    }else{
      $downFile.init(url, name)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/paging/pcClient/popupModule/structFile/downFile/index.js